/**
 * Divine Designs Apparel — PDP upsell: adds the paired product over AJAX.
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', initBundleUpsell);
  document.addEventListener('DOMContentLoaded', followChosenOptions);

  // Keeps the upsell on the shopper's color and size. No size is set on load,
  // because a tap on Add would then buy a size they never chose.
  function followChosenOptions() {
    const form = document.querySelector('[data-product-form]');
    const card = document.querySelector('#dda-bundle-upsell');
    const picker = card && card.querySelector('.dda-bundle-variant');
    if (!form || !picker) return;
    const variants = JSON.parse(card.querySelector('[data-upsell-variants]').textContent);
    const image = card.querySelector('[data-upsell-image]');
    const label = card.querySelector('[data-upsell-color-label]');

    // Option names are translated, so go by position: Color first, then Size.
    form.addEventListener('change', (e) => {
      const color = form.querySelector('input[data-option-position="1"]:checked');
      const size = form.querySelector('input[data-option-position="2"]:checked');
      const sizeChosen = size && e.target.dataset.optionPosition === '2';
      const wantedSize = sizeChosen ? size.value : picker.value && picker.selectedOptions[0].text;
      if (color && variants.some((v) => v.color === color.value)) card.dataset.upsellColor = color.value;
      const matches = variants.filter((v) => v.color === card.dataset.upsellColor);

      picker.length = 1;
      matches.forEach((v) => picker.add(new Option(v.size, v.id, false, v.size === wantedSize)));
      label.textContent = card.dataset.upsellColor;
      if (matches[0] && matches[0].image) {
        image.removeAttribute('srcset');
        image.src = matches[0].image;
      }
    });
  }

  function initBundleUpsell() {
    const bundleButtons = document.querySelectorAll('.dda-bundle-add-btn');
    bundleButtons.forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const picker = btn.closest('.dda-cross-sell-bundle').querySelector('.dda-bundle-variant');
        if (picker && !picker.reportValidity()) return;
        const variantId = picker ? picker.value : btn.getAttribute('data-variant-id');
        if (!variantId) return;

        const originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = btn.dataset.adding;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: [{ id: parseInt(variantId, 10), quantity: 1 }],
            }),
          });

          if (res.ok) {
            btn.textContent = btn.dataset.added;
            btn.style.background = '#2C332F';
            btn.style.color = '#FFF';

            // Stay on the page: leaving for /cart would strand the product being viewed.
            fetch('/cart.js')
              .then((r) => r.json())
              .then((cart) => {
                if (window.theme && window.theme.chrome) window.theme.chrome.refreshCartBubbles(cart.item_count);
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
              })
              .catch(console.error);
          } else {
            throw new Error('Failed to add item');
          }
        } catch (err) {
          console.error(err);
          btn.textContent = btn.dataset.error;
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = originalText;
          }, 2000);
        }
      });
    });
  }
})();
